import { render, staticRenderFns } from "./PersonAddresses.vue?vue&type=template&id=50a60dc8&"
import script from "./PersonAddresses.jsx?vue&type=script&lang=js&"
export * from "./PersonAddresses.jsx?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports